<div class="boxed-link-container">
  <div *ngIf="linkData.acf.isSponsored" class="boxed-link-sponsored">
    ANNONS
  </div>
  <div class="boxed-link-columns">
    <div class="boxed-link-image-container">
      <h3 [innerHTML]="linkData.title.rendered"></h3>
      <app-media-item [image]="linkData.acf.mainImage"></app-media-item>
    </div>
    <div class="boxed-link-text-container">
      <div
        [innerHTML]="linkData.content.rendered"
        class="boxed-link-text"
      ></div>

      <app-ui-button
        *ngIf="linkData.acf.url"
        [color]="'green'"
        [compressed]="false"
        [eventAction]="'click'"
        [eventCategory]="gaPreffixEnum.GUIDE_LINK"
        [eventLabel]="linkData.title.rendered"
        [eventParams]="{callToAction: gaPreffixEnum.GUIDE_LINK + ' - click', pageType: DLPageTypeEnum.OTHER_PAGE}"
        [expanded]="'block'"
        [linkTitle]="linkData.acf.buttonLabel"
        [linkUrl]="linkData.acf.url"
        [ngClass]="btnClass"
        [size]="'lg'"
        appGtmEvent
        appGtmGa4Event
        rel="nofollow"
        target="_blank"
      >
        {{ linkData.acf.buttonLabel }}
      </app-ui-button>

      <app-ui-button
        (onClick)="openModal()"
        *ngIf="
          linkData.acf.openModal &&
          linkData.acf.openModal !== '' &&
          linkData.acf.openModal !== 'none'
        "
        [color]="'green'"
        [compressed]="false"
        [eventAction]="'click'"
        [eventCategory]="gaPreffixEnum.GUIDE_LINK"
        [eventLabel]="linkData.title.rendered"
        [eventParams]="{callToAction: gaPreffixEnum.GUIDE_LINK + ' - click', pageType: DLPageTypeEnum.OTHER_PAGE}"
        [expanded]="'block'"
        [ngClass]="btnClass"
        [size]="'lg'"
        [title]="linkData.title.rendered"
        appGtmEvent
        appGtmGa4Event
        rel="nofollow"
        target="_blank"
      >
        {{ linkData.acf.buttonLabel }}
      </app-ui-button>
    </div>
  </div>
</div>
